<div class="page-wrap">
  <div class="replace-matcard">
    <mat-card-header>
      <div class="headerContainerLeft">
        <div class="headerContainerItem">
          <mat-form-field class="w-350">
            <mat-label>Choose a project</mat-label>
            <mat-select [value]="selectedProjectID" (selectionChange)="changeProjectValue($event.value)">
              <mat-option class="select-without-checkbox">{{projectDropdownTitle}}</mat-option>
              <mat-option class="select-without-checkbox" *ngFor="let project of projects" [value]="project.id">
                {{project.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="headerContainerItem">
          <mat-form-field class="w-350">
            <mat-label>Choose a carriage</mat-label>
            <mat-select [value]="selectedWagonID" (selectionChange)="changeWagon($event.value)"
              [disabled]="wagons == null">
              <mat-option class="select-without-checkbox">{{wagonDropdownTitle}}</mat-option>
              <mat-option class="select-without-checkbox" *ngFor="let wagon of wagons" [value]="wagon.id">
                {{wagon.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="headerContainerItem" *ngIf="hasSecondFloor">
          <mat-form-field>
            <mat-label>{{luggageCalculationInputTitel}}</mat-label>
            <mat-select [value]="2" (selectionChange)="changeLuggageCalculationInput($event.value)">
              <mat-option class="select-without-checkbox"
                *ngFor="let luggageCalculationInput of luggageCalculationInputSource"
                [value]="luggageCalculationInput.Value">
                {{luggageCalculationInput.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="headerContainerItem" style="margin-left: auto;">
          <!-- <button mat-raised-button class="button color"
          (click)="debug()">Debug</button> -->
          <button mat-raised-button class="button color" [disabled]="validateParameters()"
            (click)="evaluate()">{{analyseButtonText}}</button>
        </div>
      </div>
      <div class="clearfix"></div>
    </mat-card-header>
    <mat-card-content class="card-content">
      <mat-tab-group class="tab-group">
        <mat-tab>
          <ng-template mat-tab-label>{{tabTravelmixTitle}}</ng-template>
          <app-evaluation-travel-mixes class="component-style"
            [evaluationService]="evaluationService"></app-evaluation-travel-mixes>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>{{tabGraphicsTitle}}</ng-template>
          <app-evaluation-graphics class="component-style" *ngIf="evaluationService.companyGraphics; else notYetLoaded"
            [context]="'layout'" [evaluationService]="evaluationService"></app-evaluation-graphics>
          <ng-template #notYetLoaded>
            <p>Please select a project first to see this content</p>
          </ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>{{tabVariantsTitle}}</ng-template>
          <div class="component-style">
            <div class="overflow-auto mh-450" *ngIf="variantWithDoorsChecklist != null">
              <div *ngFor="let variant of variantWithDoorsChecklist;let i = index;">
                <hr *ngIf="i > 0">
                <div class="item-container">
                  <mat-checkbox [(ngModel)]="variant.isSelected" class="checkbox-style"
                    [disabled]="variant.hasCollissions"
                    (ngModelChange)="loadDoors(variant,$event);updateChild(variant,$event)" value="variant.id"
                    [title]="variant.hasCollissions ? variantCollidingObjectInfo : ''">
                    {{variant.name}}
                  </mat-checkbox>
                  <hr *ngIf="variant.doors && evaluationService.passengerAlgorithmGraphicSelected.value">
                  <div *ngIf="variant.doors && evaluationService.passengerAlgorithmGraphicSelected.value">
                    <mat-checkbox class="checkbox-style" (change)="setDoorsSelectedState(variant,true,$event.checked)"
                      [checked]="getCheckedState(variant.doors,true)"
                      [indeterminate]="getIntermediateState(variant.doors,true)" [disabled]="!variant.isSelected">
                      Select all upper doors
                    </mat-checkbox>
                    <mat-checkbox class="checkbox-style" (change)="setDoorsSelectedState(variant,false,$event.checked)"
                      [checked]="getCheckedState(variant.doors,false)"
                      [indeterminate]="getIntermediateState(variant.doors,false)" [disabled]="!variant.isSelected">
                      Select all lower doors
                    </mat-checkbox>
                  </div>
                  <div *ngIf="evaluationService.passengerAlgorithmGraphicSelected.value">
                    <mat-checkbox *ngFor="let door of variant.doors" [(ngModel)]="door.isSelected"
                      (ngModelChange)="syncVariantParamObject(variant)" [disabled]="!variant.isSelected" value="door.id"
                      class="checkbox-style">
                      {{door?.userId}}
                    </mat-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="variantWithDoorsChecklist == null && isWagonSelected; then layoutsUnavailable;">
            </div>
            <div *ngIf="variantWithDoorsChecklist == null && !isWagonSelected; then wagonUnavailable;">
            </div>
            <ng-template #layoutsUnavailable>
              <p class="m-l-15">{{layoutsUnavailableText}}</p>
            </ng-template>
            <ng-template #wagonUnavailable>
              <p class="m-l-15">{{wagonUnavailableText}}</p>
            </ng-template>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>{{tabAdvancedSettingsTitle}}</ng-template>
          <app-evaluation-advanced-settings [evaluationService]="evaluationService"
            (onSaveAsProjectDefault)="loadProjects()" class="component-style"></app-evaluation-advanced-settings>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </div>
</div>
<hr class="line">